import {IdCodeNameQuery} from 'common-shared';

export class ProcessQuery extends IdCodeNameQuery {
  Number?: number;
  Comment: string;

  static Columns() {
    return [...IdCodeNameQuery.Columns(), 'Number', 'Comment'];
  }
}

